import i18next from 'i18next';
import React from 'react';
import { Link, Route } from 'react-router-dom';

const SideBarMenuItem = (props) => (
    <Route
        path={props.to}
        exact
        children={({ match }) => (
            <li className={`dashboard__menu ${match ? 'menu-active' : ''}`}>
                <i
                    style={{ marginLeft: i18next.dir() === 'rtl' ? '1rem' : 0 }}
                    className={props.icon}
                />
                <Link to={props.to}>{props.title}</Link>
            </li>
        )}
    />
);

export default SideBarMenuItem;
